/**
 * 门户锚点默认配置数据
 */
export const home = [
  // {
  //   styleId: 1,
  //   styleType: "horizontal",
  //   width: 300,
  //   height: 44
  // },
  // { styleId: 2, styleType: "vertical", indent: 12, width: 300, height: 160, anchorWidth: 300, anchorHeight: 46 }
  {
    styleId: 1,
    styleType: "horizontal",
    hoverBackground: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: true,
        color: "#3D82F2"
      }
    ],
    color: {
      data: {
        stops: [
          ["rgba(126,125,141,1)", 0],
          ["rgba(0,0,0,1)", 1]
        ],
        angle: 0
      },
      color: "rgba(126,125,141,1)",
      type: "color",
      label: "颜色"
    },
    hoverColor: {
      data: {
        stops: [
          ["rgba(255,255,255,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ],
        angle: 0
      },
      color: "rgba(255,255,255,1)"
    },
    activeColor: {
      data: {
        stops: [
          ["rgba(255,255,255,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ],
        angle: 0
      },
      color: "rgba(255,255,255,1)"
    },
    defaultBackground: [
      {
        data: {
          stops: [
            ["rgba(243,243,246,1)", 0],
            ["rgba(246,206,1,1)", 1]
          ],
          angle: 0
        },
        type: "color",
        label: "颜色",
        isThemeColor: false,
        color: "rgba(243,243,246,1)"
      }
    ],
    background: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: false,
        color: "rgba(255,255,255,0)"
      }
    ],
    activeBackground: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: true,
        color: "#3D82F2"
      }
    ],
    iconColor: {
      data: {
        stops: [
          ["#000", 0],
          ["#000", 1]
        ],
        angle: 0
      },
      color: "#000"
    },
    resInfo: {},
    fontSize: 14,
    activeFontSize: 14,
    activeFontWeight: 600,
    lineHeight: 26,
    activeLineHeight: 26,
    anchorWidth: "auto",
    anchorHeight: 100,
    anchorWidthType: "自动",
    anchorHeightType: "%",
    contentHasLimit: true,
    textLimitLines: 8,
    paddingTypeFlag: 2,
    paddingTop: 4,
    paddingRight: 24,
    paddingLeft: 24,
    paddingBottom: 4,
    marginRight: 24,
    marginBottom: 8,
    menuName: "锚点",
    showAllBorder: false,
    borderRadius: 0,
    allBorderTypeFlag: 2,
    activeCol: "",
    borderTypeFlag: 2,
    contentHasLimitRadio: "字数",
    name: "样式一",
    hoverIsSameActive: true,
    cover: require("../../../assets/images/leftMenu/anchor/style1.png")
  }
  // {
  //   styleId: 2,
  //   styleType: "vertical",
  //   indent: 12,
  //   width: 300,
  //   height: 160,
  //   anchorWidth: 300,
  //   anchorHeight: 46,
  //   name: "竖向样式",
  //   cover: require("../assets/images/anchor2.png")
  // }
]

/**
 * 大屏锚点默认配置数据
 */
export const bs = []

/**
 * app锚点默认配置数据
 */
export const appHome = home
